import React from "react";
import { Modal } from "react-bootstrap";
import "./CreateCertificateTemplate.css";
// import CreateCertificateTemplate from '../modalForm/CreateCertificateTemplate';


function CreateCertificateTemplate({
  show,
  onHide,
  centered = true,
  backdrop = "static",
  keyboard = false,
  children,
}) {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered={centered}
      dialogClassName="custom-modal-dialog"
      backdrop={backdrop}
      keyboard={keyboard}
      style={{ zIndex: "9999" }}
      className="bg-transparent"
    >
      <div
        className="row d-flex justify-content-center align-items-center w-100 bg-transparent"
        style={{ marginTop: "10px" }}
      >
        <div
          className="bg-white"
          style={{
            minWidth: "580px",
            padding: "5px",
            borderRadius: "10px",
            overflow: "hidden",
            marginLeft: "20px",
          }}
        >
          {children}
        </div>
      </div>
    </Modal>
  );
}

export default CreateCertificateTemplate;